export const MCQ = "MCQ";
export const IQ = "IQ";
export const FILL_IN_THE_BLANK = "FILL IN THE BLANK";
export const TRUE_FALSE = "TRUE FALSE";
export const SHORT_ANSWER = "SHORT ANSWER";
export const RESEARCH = "RESEARCH";
export const MATCHING = "MATCHING";
export const ANIMATION = "ANIMATION";
export const ASSERTION_REASONING = "ASSERTION REASONING";
